import { useState } from "react";

const useChartData = () => {
  const [bigFiveData, setBigFiveData] = useState({
    labels: [
      "Openness",
      "Conscientiousness",
      "Extraversion",
      "Agreeableness",
      "Neuroticism",
    ],
    datasets: [
      {
        label: "Big Five Score",
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          '#FFD700', 
        '#FFA500', 
        '#FF8C00',
        '#EA650D', 
        '#E55100',
        '#D84315', 
        ],
        borderColor: "rgba(255, 255, 255, 1)",
        borderWidth: 2,
      },
    ],
  });

  const [discData, setDiscData] = useState({
    labels: ["Dominantie", "Invloed", "Stabiliteit", "Consciëntieusheid"],
    datasets: [
      {
        data: [25, 30, 20, 25],
        backgroundColor: [
          '#FFD700', 
          '#FFA500', 
          '#FF8C00',
          '#EA650D', 
          '#E55100',
          '#D84315', 
        ],
        borderColor: ["#ffffff", "#ffffff", "#ffffff", "#ffffff"],
        borderWidth: 2,
      },
    ],
  });

  const [riasecData, setRiasecData] = useState({
    labels: [
      "Realistisch",
      "Onderzoekend",
      "Artistiek",
      "Sociaal",
      "Ondernemend",
      "Conventioneel",
    ],
    datasets: [
      {
        label: "RIASEC Score",
        data: [2, 5, 3, 4, 3, 5],
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "#A02F08",
        borderWidth: 2,
        pointBackgroundColor: [
          '#FFD700', 
          '#FFA500', 
          '#FF8C00',
          '#EA650D', 
          '#E55100',
          '#D84315', 
        ],
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#A02F08",
        pointRadius: 5,
      },
    ],
  });

  const [mbtiData, setMbtiData] = useState({
    labels: [
      "Extraversion (E)",
      "Intuition (N)",
      "Thinking (T)",
      "Judging (J)",
    ],
    datasets: [
      {
        label: "MBTI Score",
        data: [75, 68, 82, 70],
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "#A02F08",
        borderWidth: 2,
        pointBackgroundColor: [
          '#FFD700', 
        '#FFA500', 
        '#FF8C00',
        '#EA650D', 
        '#E55100',
        '#D84315', 
        ],
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#A02F08",
        pointRadius: 5,
      },
    ],
  });

  return {
    bigFiveData,
    setBigFiveData,
    discData,
    setDiscData,
    riasecData,
    setRiasecData,
    mbtiData,
    setMbtiData,
  };
};

export default useChartData;
